module.exports = __webpack_public_path__ + "img/bannerDetailInfo.a8dfb35b.png";